import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Home"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-home',
    templateUrl: './icon-home.component.html',
    styleUrls: ['./icon-home.component.scss'],
    standalone: false
})
export class IconHomeComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
